import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

const AuthContext = createContext({
    user: null,
    userDoc: null,
    isAdmin: false,
    isSuspended: false,
    loading: true,
});

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [userDoc, setUserDoc] = useState(null);
    const [adminClaim, setAdminClaim] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
            if (!firebaseUser) {
                setUserDoc(null);
                setAdminClaim(false);
                setLoading(false);
            }
        });
        return unsub;
    }, []);

    useEffect(() => {
        if (!user) { setUserDoc(null); setAdminClaim(false); return; }
        let active = true;
        user.getIdTokenResult()
            .then((token) => {
                if (active) setAdminClaim(Boolean(token?.claims?.admin));
            })
            .catch(() => {
                if (active) setAdminClaim(false);
            });
        const unsub = onSnapshot(doc(db, 'users', user.uid), (snap) => {
            if (snap.exists()) {
                setUserDoc(snap.data());
            } else {
                setUserDoc(null);
            }
            setLoading(false);
        }, (err) => {
            console.error('AuthContext user doc listener error:', err);
            setUserDoc(null);
            setLoading(false);
        });
        return () => {
            active = false;
            unsub();
        };
    }, [user]);

    const isAdmin = adminClaim;
    const isSuspended = Boolean(userDoc?.suspended);

    return (
        <AuthContext.Provider value={{ user, userDoc, isAdmin, isSuspended, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}

export default AuthContext;
